// import external dependencies
import 'jquery';
import 'owl.carousel';
import AOS from 'aos/dist/aos';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Load Modules
import './modules/winners';
import './modules/videos';
import './modules/mousemove';
import './modules/menu';
import './modules/forms';
import './modules/partners';

// Animate On Scroll
AOS.init({
    disable: 'mobile',
    once: true,
});



// WEBPACK FOOTER //
// ./scripts/main.js